module.exports = __webpack_public_path__ + "img/outstock.bad4628a.svg";